import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import MobileMenu from '../MobileMenu/MobileMenu';
import Logo from '@images/logo.svg';
import SimpleReactValidator from 'simple-react-validator';
import { LanguageContext } from '../../index';

const Header = (props) => {
    const [menuActive, setMenuState] = useState(false);
    const [SearchActive, setSearchState] = useState(false);

    const { language, setLanguage } = useContext(LanguageContext);

    const handleLanguageChange = (e) => {
        setLanguage(e.target.value);
    };

    const [forms, setForms] = useState({
        name: '',
        email: '',
        message: ''
    });
    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));
    const [result, setResult] = useState(null);
    const changeHandler = e => {
        setForms({ ...forms, [e.target.name]: e.target.value });
        if (validator.allValid()) {
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };

    const submitHandler = async e => {
        e.preventDefault();
        console.log("SUBMIT!");
        if (validator.allValid()) {
            validator.hideMessages();
            try {
                const response = await fetch('/send-email.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(forms),
                });

                const result = await response.json();
                setResult('success');
                console.log('Post result:', result);
            } catch (error) {
                setResult('error');
                console.error('An error occurred:', error.message);
                // alert('An error occurred: ' + error.message);
            }
            setForms({
                name: '',
                email: '',
                message: ''
            });
        } else {
            validator.showMessages();
        }
    };

    const ClickHandler = () => {
        window.scrollTo(10, 0); 
    };

    const content = {
        en: {
            address: 'Address:',
            call: 'Call:',
            home: 'Home',
            homeStyle1: 'Home Style 1',
            homeStyle2: 'Home Style 2',
            aboutUs: 'About Us',
            projects: 'Projects',
            services: 'Cooperation',
            blog: 'Blog',
            contact: 'Contact',
            askQuestion: 'Ask a Question',
            name: 'Name',
            email: 'Email',
            phone: 'Phone',
            message: 'Message',
            send: 'Send',
        },
        pl: {
            address: 'Adres:',
            call: 'Zadzwoń:',
            home: 'Strona główna',
            homeStyle1: 'Styl Strony 1',
            homeStyle2: 'Styl Strony 2',
            aboutUs: 'O nas',
            projects: 'Projekty',
            services: 'Współpraca',
            blog: 'Blog',
            contact: 'Kontakt',
            askQuestion: 'Zadaj pytanie',
            name: 'Imię',
            email: 'Email',
            phone: 'Telefon',
            message: 'Wiadomość',
            send: 'Wyślij',
        },
    };

    const t = content[language];

    return (
        <header className="main-header">
            <div className="header-top">
                <div className="container">
                    <div className="top-inner">
                        <div className="logo-outer">
                            <div className="logo">
                                <Link onClick={ClickHandler} to="/">
                                    <img src={Logo} alt="Logo" />
                                </Link>
                            </div>
                        </div>

                        <ul className="header-info">
                            <li>
                                <i className="fa fa-map-marker"></i>
                                <h6>
                                    <span>{t.address}</span>
                                    Kraków, ul. Zakopiańska 56 (lokal nr 24)
                                </h6>
                            </li>
                            <li>
                                <i className="fa fa-phone"></i>
                                <h6>
                                    <span>{t.call}</span>
                                    506 708 825 / 538 368 480
                                </h6>
                            </li>
                        </ul>
                        <div className="languages">
                            <select name="languages" id="languages" value={language} onChange={handleLanguageChange}>
                                <option value="en">English</option>
                                <option value="pl">Polski</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div className="header-upper">
                <div className="container clearfix">
                    <div className="header-inner">
                        <div className="nav-outer clearfix">
                            <nav className="main-menu navbar-expand-lg">
                                <MobileMenu />
                                <div className="navbar-collapse collapse clearfix">
                                    <ul className="navigation clearfix">
                                        <li className="current">
                                            <Link onClick={ClickHandler} to="/">{t.home}</Link>
                                            {/* <ul>
                                                <li><Link onClick={ClickHandler} to="/home">{t.homeStyle1}</Link></li>
                                                <li><Link onClick={ClickHandler} to="/home2">{t.homeStyle2}</Link></li>
                                            </ul> */}
                                        </li>
                                        <li><Link onClick={ClickHandler} to="/about">{t.aboutUs}</Link></li>
                                        <li>
                                            <Link onClick={ClickHandler} to="/projects">{t.projects}</Link>
                                            {/* <ul>
                                                <li><Link onClick={ClickHandler} to="/projects">{t.projects}</Link></li>
                                                <li><Link onClick={ClickHandler} to="/project-single/Architecture">{t.projectSingle}</Link></li>
                                            </ul> */}
                                        </li>
                                        <li>
                                            <Link onClick={ClickHandler} to="/services">{t.services}</Link>
                                            {/* <ul>
                                                <li><Link onClick={ClickHandler} to="/services">{t.services}</Link></li>
                                                <li><Link onClick={ClickHandler} to="/service-single/Design-&-Planning">{t.servicesSingle}</Link></li>
                                            </ul> */}
                                        </li>
                                        <li>
                                            <Link onClick={ClickHandler} to="/blog">{t.blog}</Link>
                                            {/* <ul>
                                                <li><Link onClick={ClickHandler} to="/blog">{t.blog}</Link></li>
                                                <li><Link onClick={ClickHandler} to="/blog-single/Serverless-Stream-Based-Processing">{t.blogSingle}</Link></li>
                                            </ul> */}
                                        </li>
                                        <li><Link onClick={ClickHandler} to="/contact">{t.contact}</Link></li>
                                    </ul>
                                </div>
                            </nav>
                        </div>

                        <div className="menu-icons">
                            <div className="menu-sidebar">
                                <button onClick={() => setMenuState(!menuActive)}>
                                    <span className="icon-bar"></span>
                                    <span className="icon-bar"></span>
                                    <span className="icon-bar"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`sidebar-wrap ${menuActive ? "side-content-visible" : ""}`}>
                <div className="form-back-drop" onClick={() => setMenuState(!menuActive)}></div>
                <section className="hidden-bar">
                    <div className="inner-box text-center">
                        <div className="cross-icon" onClick={() => setMenuState(!menuActive)}>
                            <span className="fa fa-times"></span>
                        </div>
                        <div className="title">
                            <h3>{t.askQuestion}</h3>
                        </div>
                        <div className="appointment-form">
                            <form method="post" onSubmit={(e) => submitHandler(e)}>
                                <div className="form-group">
                                    <input
                                        value={forms.name}
                                        type="text"
                                        name="name"
                                        onBlur={(e) => changeHandler(e)}
                                        onChange={(e) => changeHandler(e)}
                                        placeholder={t.name}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        value={forms.email}
                                        type="email"
                                        name="email"
                                        onBlur={(e) => changeHandler(e)}
                                        onChange={(e) => changeHandler(e)}
                                        placeholder={t.email}
                                        required 
                                    />
                                </div>
                                <div className="form-group">
                                    <textarea
                                        rows="5"
                                        type="text"
                                        name="message"
                                        onBlur={(e) => changeHandler(e)}
                                        onChange={(e) => changeHandler(e)}
                                        value={forms.message}
                                    >
                                    </textarea>
                                </div>
                                {result === 'success' && (
                                    <div>
                                        <div className="alert alert-success" role="alert">
                                            {language === 'pl' ? 'Wiadomość została wysłana pomyślnie!' : 'Message sent successfully!'}
                                        </div>
                                    </div>
                                )}
                                {result === 'error' && (
                                    <div>
                                        <div className="alert alert-danger" role="alert">
                                            {language === 'pl' ? 'Wystąpił błąd podczas wysyłania wiadomości.' : 'An error occurred while sending the message.'}
                                        </div>
                                    </div>
                                )}
                                <div className="form-group">
                                    <button type="submit" className="theme-btn">{t.send}</button>
                                </div>
                            </form>
                        </div>
                        <div className="social-icons">
                            <Link to="/"><i className="fa fa-facebook-f"></i></Link>
                            <Link to="/"><i className="fa fa-instagram"></i></Link>
                            <Link to="/"><i className="fa fa-pinterest-p"></i></Link>
                            <Link to="/"><i className="fa fa-youtube"></i></Link>
                        </div>
                    </div>
                </section>
            </div>
        </header>
    );
};

export default Header;